import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageDisplayModule } from '../../validation-messages-display/message-display.module';
import { AddAddonDialogComponent } from 'src/app/modules/accounts/view-account/license-details/add-addon-dialog/add-addon-dialog.component';
// tslint:disable-next-line:max-line-length
import { RemoveAddonDialogComponent } from 'src/app/modules/accounts/view-account/license-details/remove-addon-dialog/remove-addon-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// tslint:disable-next-line: max-line-length
import { RevertAddonDialogComponent } from 'src/app/modules/accounts/view-account/license-details/revert-addon/revert-addon-dialog.component';
// tslint:disable-next-line: max-line-length
import { RevertCorpAddonDialogComponent } from 'src/app/modules/accounts/view-account/license-details/revert-corp-addon/revert-corp-addon-dialog.component';
import { AddAddonDialoggComponent } from 'src/app/modules/accounts/view-account/license-details/add-addon-dialogg/add-addon-dialogg.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    imports: [
        CommonModule,
        MessageDisplayModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        AddAddonDialogComponent,
        AddAddonDialoggComponent,
        RevertAddonDialogComponent,
        RevertCorpAddonDialogComponent,
        RemoveAddonDialogComponent
    ]
})
export class AddonModule { }
